<template>
  <el-container style="height: 89vh">
    <Sidebar :list="treeData" ref="sidebar" />
    <el-container>
      <el-main>
        <appMain ref="appMain" />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Sidebar from '@/components/AppMainSidebar'; // 侧边栏
import appMain from './components/appMain';
import { getPageTreeApi } from '@/api/areaApi';
export default {
  name: 'City',
  components: {
    Sidebar,
    appMain,
  },
  data() {
    return {
      treeData: [],
    };
  },
  provide() {
    return {
      getAreaList: this.getAreaList,
    };
  },
  created() {
    this.getAreaList();
  },
  methods: {
    async getAreaList() {
      try {
        let res = await getPageTreeApi();
        this.treeData = res.data.treeData;
        // console.log('路由', this.treeData);
        this.$refs.sidebar.expandedList = [res.data.treeData[0].areaId];
        this.$store.dispatch('area/setAreaAllList', this.treeData);
        // 转换成checkNode节点相似的数据结构，添加data对象，
        let obj = this.treeData[0];
        obj.data = {};
        obj.data.areaId = obj.areaId;
        let newObj = JSON.parse(
          JSON.stringify(obj).replace(/childTree/g, 'childNodes')
        );
        this.$store.dispatch('area/setCheckNodeData', newObj);
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
